import { useState } from "react";
import { API_URL } from "../../../utils/common";

export interface UpdatePerfilRequest {
    id: number;
    nombre: string;
    descripcion: string;
}

export const useUpdateUserPerfil = () => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const getToken = () => localStorage.getItem("jwt");

    const actualizarPerfil = async (
        payload: UpdatePerfilRequest
    ): Promise<boolean> => {

        setLoading(true);
        setError(null);

        try {

            const token = getToken();

            if (!token) {
                throw new Error("Token no encontrado");
            }

            const response = await fetch(
                `${API_URL}/cms/admin/perfiles/${payload.id}`,
                {
                    method: "PUT",
                    headers: {
                        Authorization: `bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            if (!response.ok) {

                const data = await response.json().catch(() => null);

                throw new Error(
                    data?.message ??
                    "Error al actualizar el perfil"
                );

            }

            return true;

        } catch (err: any) {

            console.error(err);

            setError(
                err.message || "Ocurrió un error"
            );

            return false;

        } finally {

            setLoading(false);

        }

    };

    return {

        actualizarPerfil,
        loading,
        error,

    };

};